function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.535 7l3.098-3.1a1.252 1.252 0 000-1.77L11.864.36a1.268 1.268 0 00-1.769 0l-3.099 3.1L3.907.36a1.268 1.268 0 00-1.769 0L.36 2.13a1.27 1.27 0 000 1.77L3.458 7 .369 10.1a1.252 1.252 0 000 1.77l1.77 1.77c.478.48 1.28.48 1.768 0l3.09-3.1 3.098 3.1c.489.48 1.28.48 1.77 0l1.768-1.77a1.252 1.252 0 000-1.77L10.535 7z",
  fill: "currentColor"
});

var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 22 22",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgCloseIcon;